import React, { Component } from 'react';
import { InputGroup, Row, Col, Table, Image } from 'react-bootstrap';
import NumericTextboxComponent from 'react-numeric-textbox';

class SingleStemCalcDiameter extends Component {
    constructor() {
        super();

        this.state = {
            incursionType: 1,
            stemType: 1,
            mesType: 1,
            dbh: 0,
            DatBase: 0,
            srz: 1.5,
            srzarea: 0,
            tpzradius: 2,
            tpzarea: 12.6
        }

    }

    // Run calcs for the first time
    componentDidMount = () => {
        this.updateDBH(0)
        this.updateSRZ(0)
    }


    updateDBH = (e) => {

        var dbh = Number(e)
        var tempTPZradius = dbh * 12 / 100

        if (tempTPZradius <= 2) {
            tempTPZradius = 2;
        } else if (tempTPZradius >= 15) {
            tempTPZradius = 15;
        }

        var tpzarea = tempTPZradius * tempTPZradius * Math.PI

        this.setState({
            dbh: dbh,
            tpzradius: tempTPZradius,
            tpzarea: tpzarea
        })

        this.props.pCallback({ tpzradius: tempTPZradius, tpzarea: tpzarea, srz: this.state.srz })


    }

    updateSRZ = (e) => {

        var DatBase = Number(e)
        var srz = Math.pow(DatBase / 2, 0.42) * 0.64

        if (srz <= 1.5) {
            srz = 1.5
        }

        var srzarea = srz * srz * Math.PI

        this.setState({
            DatBase: DatBase,
            srz: srz,
            srzarea: srzarea
        })

        this.props.pCallback({ tpzradius: this.state.tpzradius, tpzarea: this.state.tpzarea, srz: srz })

    }

    render() {
        return (
            <div>
                <Row>
                    <Col xs={{ order: 12 }} sm={{ order: 12 }}>
                        <label>Diameter (cm) of stem measured at 1.4m above ground.</label>
                        <InputGroup className="mb-3">
                            <NumericTextboxComponent
                                className="form-control"
                                min={0}
                                decimals={1}
                                value={0}
                                format={'0.0'}
                                onChange={this.updateDBH}
                                autoCorrect={true}
                            />
                            <InputGroup.Append>
                                <InputGroup.Text id="basic-addon2">cm</InputGroup.Text>
                            </InputGroup.Append>
                        </InputGroup>
                        <Table responsive>
                            <tbody>
                                <tr>
                                    <td>NRZ radius (m)</td>
                                    <td class="text-right">{this.state.tpzradius.toFixed(1)}</td>
                                </tr>
                                <tr>
                                    <td>NRZ area (m²)</td>
                                    <td class="text-right">{this.state.tpzarea.toFixed(1)}</td>
                                </tr>
                            </tbody>
                        </Table>
                        <label>Diameter (cm) measured immediately above the root buttress.</label>
                        <InputGroup className="mb-3">
                            <NumericTextboxComponent
                                className="form-control"
                                min={0}
                                decimals={1}
                                value={0}
                                format={'0.0'}
                                onChange={this.updateSRZ}
                                autoCorrect={true}
                            />
                            <InputGroup.Append>
                                <InputGroup.Text id="basic-addon2">cm</InputGroup.Text>
                            </InputGroup.Append>
                        </InputGroup>
                        <Table responsive>
                            <tbody>
                                <tr>
                                    <td>SRZ radius (m)</td>
                                    <td class="text-right">{this.state.srz.toFixed(1)}</td>
                                </tr>
                                <tr>
                                    <td>SRZ area (m²)</td>
                                    <td class="text-right">{this.state.srzarea.toFixed(1)}</td>
                                </tr>
                            </tbody>
                        </Table>
                    </Col>
                    <Col xs={{ span: 12, order: 'first' }} sm={{ span: 12, order: 'first' }} md={{ span: 4, order: 12 }} lg={{ span: 4, order: 12 }}>
                    <br />
                        <Image src="https://storage.googleapis.com/as4970-2025/Single_stem_DSH_DAB_graphic.png" height="300" />
                        <p>
                            <small>
                                Measuring DSH/DAB for a single stem/trunk tree.<sup>1</sup>
                            </small>
                        </p>
                    </Col>
                    <Col xs={0} sm={0} md={{ span: 2, order: 'last' }} lg={{ span: 2, order: 'last' }}></Col>
                </Row>
            </div>
        )
    }
}

class SingleStemCalcCircumference extends Component {
    constructor() {
        super();

        this.state = {
            incursionType: 1,
            stemType: 1,
            mesType: 1,
            dbh: 0,
            DatBase: 0,
            srz: 0,
            srzarea: 1.5,
            tpzradius: 2,
            tpzarea: 12.6
        }

    }

    // Run calcs for the first time
    componentDidMount = () => {
        this.updateDBH(0)
        this.updateSRZ(0)
    }


    updateDBH = (e) => {

        var circ = Number(e)

        //var dbh = Number(e)
        var dbh = circ / Math.PI

        var tempTPZradius = dbh * 12 / 100

        if (tempTPZradius <= 2) {
            tempTPZradius = 2;
        } else if (tempTPZradius >= 15) {
            tempTPZradius = 15;
        }

        var tpzarea = tempTPZradius * tempTPZradius * Math.PI

        this.setState({
            dbh: dbh,
            tpzradius: tempTPZradius,
            tpzarea: tpzarea
        })

        this.props.pCallback({ tpzradius: tempTPZradius, tpzarea: tpzarea, srz: this.state.srz })


    }

    updateSRZ = (e) => {
        var circ = Number(e)
        var DatBase = circ / Math.PI
        var srz = Math.pow(DatBase / 2, 0.42) * 0.64

        if (srz <= 1.5) {
            srz = 1.5
        }

        var srzarea = srz * srz * Math.PI

        this.setState({
            DatBase: DatBase,
            srz: srz,
            srzarea: srzarea
        })

        this.props.pCallback({ tpzradius: this.state.tpzradius, tpzarea: this.state.tpzarea, srz: srz })

    }

    render() {
        return (
            <div>
                <Row>
                    <Col xs={{ order: 12 }} sm={{ order: 12 }}>
                        <label>Circumference (cm) of stem measured at 1.4m above ground.</label>
                        <InputGroup className="mb-3">
                            <NumericTextboxComponent
                                className="form-control"
                                min={0}
                                decimals={1}
                                value={0}
                                format={'0.0'}
                                onChange={this.updateDBH}
                                autoCorrect={true}
                            />
                            <InputGroup.Append>
                                <InputGroup.Text id="basic-addon2">cm</InputGroup.Text>
                            </InputGroup.Append>
                        </InputGroup>
                        <Table responsive>
                            <tbody>
                                <tr>
                                    <td>DSH (cm)</td>
                                    <td class="text-right">{this.state.dbh.toFixed(1)}</td>
                                </tr>
                                <tr>
                                    <td>NRZ radius (m)</td>
                                    <td class="text-right">{this.state.tpzradius.toFixed(1)}</td>
                                </tr>
                                <tr>
                                    <td>NRZ area (m²)</td>
                                    <td class="text-right">{this.state.tpzarea.toFixed(1)}</td>
                                </tr>
                            </tbody>
                        </Table>
                        <label>Circumference (cm) measured immediately above the root buttress.</label>
                        <InputGroup className="mb-3">
                            <NumericTextboxComponent
                                className="form-control"
                                min={0}
                                decimals={1}
                                value={0}
                                format={'0.0'}
                                onChange={this.updateSRZ}
                                autoCorrect={true}
                            />
                            <InputGroup.Append>
                                <InputGroup.Text id="basic-addon2">cm</InputGroup.Text>
                            </InputGroup.Append>
                        </InputGroup>
                        <Table responsive>
                            <tbody>
                                <tr>
                                    <td>DAB (cm)</td>
                                    <td class="text-right">{this.state.DatBase.toFixed(1)}</td>
                                </tr>
                                <tr>
                                    <td>SRZ radius (m)</td>
                                    <td class="text-right">{this.state.srz.toFixed(1)}</td>
                                </tr>
                                <tr>
                                    <td>SRZ area (m²)</td>
                                    <td class="text-right">{this.state.srzarea.toFixed(1)}</td>
                                </tr>
                            </tbody>
                        </Table>
                    </Col>
                    <Col xs={{ span: 12, order: 'first' }} sm={{ span: 12, order: 'first' }} md={{ span: 4, order: 12 }} lg={{ span: 4, order: 12 }}>
                        <br />
                        <Image src="https://storage.googleapis.com/as4970-2025/Single_stem_DSH_DAB_graphic.png" height="300" />
                        <p>
                            <small>
                                Measuring DSH/DAB for a single stem/trunk tree.<sup>1</sup>
                            </small>
                        </p>
                    </Col>
                    <Col xs={0} sm={0} md={{ span: 2, order: 'last' }} lg={{ span: 2, order: 'last' }}></Col>
                </Row>
            </div>
        )
    }
}

export { SingleStemCalcDiameter, SingleStemCalcCircumference };